/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import * as yup from 'yup';

import { NO_ONLY_SPACES_REGEX } from '../../../util/validation/constants';
import { Salesforce as messages } from '../messages';
// import { buttonCodeRegex, deploymentCodeRegex } from './helpers';

export const settingsSchema = yup.object().shape({
  subscription: yup.object().shape({
    auth: yup.object().shape({
      public_token: yup.string().default('')
    }),
    account: yup.object().shape({
      id: yup.string().default('')
    }),
    data: yup.object().shape({
      organizationId: yup.string().default(''),
      buttonId: yup.string().default(''),
      sfDomain: yup.string().default(''),
      deploymentCode: yup
        .string()
        .required(messages.invalidCode)
        .matches(
          /^(.|\n)*<script.*>(.|\n)*liveagent.init\('(.*)',\s?'(.*)',\s?'(.*)'\)(.|\n)*<\/script>(.|\n)*$/,
          {
            message: messages.invalidCode,
            excludeEmptyString: true
          }
        )
        .matches(NO_ONLY_SPACES_REGEX, {
          message: messages.invalidCode,
          excludeEmptyString: true
        })
        .default(''),
      buttonCode: yup
        .string()
        .required(messages.invalidCode)
        .matches(/^(.|\n)*<a.*>(.|\n)*?<\/script>(.|\n)*$/, {
          message: messages.invalidCode,
          excludeEmptyString: true
        })
        .matches(NO_ONLY_SPACES_REGEX, {
          message: messages.invalidCode,
          excludeEmptyString: true
        })
        .default('')
    })
  })
});

export const FIELDS = {
  ACCOUNT_ID: 'subscription.account.id',
  BUTTON_CODE: 'subscription.data.buttonCode',
  BUTTON_ID: 'subscription.data.buttonId',
  ORGANIZATION_DEPLOYMENT_CODE: 'subscription.data.deploymentCode',
  ORGANIZATION_ID: 'subscription.data.organizationId',
  SALESFORCE_DOMAIN: 'subscription.data.sfDomain'
};
